export type EditorPageCandidate = {
  id?: string | null;
  page_name: string;
  jsx_content?: string | null;
  has_jsx_content?: boolean;
  compiled_html?: string | null;
  has_compiled_html?: boolean;
  generation_in_progress?: boolean;
};

const isLandingPage = (pageName: string): boolean => (
  ['landing', 'home', 'homepage'].includes(pageName.toLowerCase().replace(/[^a-z0-9]/g, ''))
);

export const getCompletedEditorPages = <Page extends EditorPageCandidate>(pages: Page[] = []): Page[] => {
  const readyPages = pages.filter((page) => (
    Boolean(page.id)
    && Boolean(page.page_name)
    && Boolean(page.jsx_content || page.has_jsx_content)
    && Boolean(page.compiled_html || page.has_compiled_html)
    && !page.generation_in_progress
  ));
  const landingIndex = readyPages.findIndex((page) => isLandingPage(page.page_name));

  if (landingIndex <= 0) return readyPages;

  return [readyPages[landingIndex], ...readyPages.filter((_page, index) => index !== landingIndex)];
};
